<template>
  <div class="content menuAdmin">
    <el-form :inline="true" class="demo-form-inline pageHead">
      <el-form-item>
        <span class="pagetitle">项目工程节点</span>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="dialogFormVisible = true">添加</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;padding:0 10px;"
      height="calc( 100% - 80px )"
      row-key="id"
      border
      :tree-props="{children: 'childList', hasChildren: 'hasChildren'}">
      <template slot="empty">
        <p>{{dataText}}</p>
      </template>
      <el-table-column prop="nodeTypeName" label="节点名称" sortable >
      </el-table-column>
      <el-table-column prop="type" label="建筑类型">
        <template slot-scope="scope" >
          <span>{{getType(scope.row.nodeType)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        sortable>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加菜单的弹出框 -->
    <el-dialog :title="tipTitle" width="30%" style="padding:0 20px;" top="5vh" :visible.sync="dialogFormVisible" @closed="closeFun">
      <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm" hide-required-asterisk='true'>
        <el-form-item label="上级节点">
          <el-input v-model="form.parentName" autocomplete="off" readonly @focus="innerVisible = true"></el-input>
        </el-form-item>
        <el-form-item label="节点名称" prop="nodeTypeName">
          <el-input v-model="form.nodeTypeName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="项目类型">
          <el-select v-model="form.nodeType" placeholder="请选择">
            <el-option
              v-for="item in ports"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"  @click="submitForm('ruleForm')">确 定</el-button>
      </div>
      <!-- 内部弹出框 -->
      <el-dialog
        width="30%"
        title="菜单列表"
        :visible.sync="innerVisible"
        append-to-body>
        <el-tree :data="tableData" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary"  @click="choseTree">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
  import myHttp from "../../../untils/port.js";
  import util from "../../../untils/util.js"
  import base from '../../../untils/base'
  export default{
    data(){
      return{
        groupId:'',
        tableData:[],
        dialogFormVisible: false,
        innerVisible: false,
        uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
        tipTitle:'菜单添加',
        form: {
          id:'',
          nodeTypeName: '',
          parentName:'',
          parentId:'',
          nodeType:'',
          sort:'',
          linkId:''
        },
        rules:{
          nodeTypeName: [
            { required: true, message: '请输入节点名称', trigger: 'blur' }
          ],
        },
        parent:{
          name:'',
          id:''
        },
        defaultProps:{
          children: 'childList',
          label: 'nodeTypeName'
        },
        uploadHead:{
          accessToken:this.$store.state.token
        },
        dataText:"数据加载中...",
        ports:[  //端
          
        ],
      }
    },
    mounted(){
      this.groupId = util.session.get('groupId')
      this.getMenu()
      this.zidian()
    },
    methods:{
      //获取菜单
      getMenu(){
        var that = this;
        myHttp.proNodeList({
          nodeType:'',
          linkId:this.groupId
        }).then(function(resp){
          if(resp.data.code=="200"){
              var list = resp.data.data.list||[];
              for(var i=0;i<list.length;i++){
                for(var j=0;j<list[i].childList.length;j++){
                  list[i].childList[j].parentName = list[i].nodeTypeName
                  list[i].childList[j].parentId = list[i].id
                }
              }
              that.tableData = list;
              if(that.tableData.length==0){
                that.dataText='暂无数据'
              }
          }else{
              that.$message.error(resp.data.msg);
              that.dataText='暂无数据'
          }
        },function(){});
      },
      //项目类型
      zidian(){
        var that = this
        myHttp.getDictByType({
          type:'project_type'
        }).then(function(resp){
          if(resp.data.code=='200'){
            var list = resp.data.data.dictList||[]
            that.ports = list
          }
        })
      },
      //根据id获取名称
      getType(id){
        var list = this.ports
        var result = ''
        for(var i=0;i<list.length;i++){
          if(id==list[i].value){
            result = list[i].label
          }
        }
        return result
      },

      //菜单树弹点击事件
      handleNodeClick(data){
        console.log(data)
        this.parent.name = data.nodeTypeName;
        this.parent.id = data.id;
      },
      //点击确认
      choseTree(){
        this.form.parentName = this.parent.name;
        this.form.parentId = this.parent.id;
        this.innerVisible = false;
      },
      //提交表格数据
      submitForm(formName){
        var that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.form.linkId = that.groupId
            if(that.form.id==""){
              myHttp.addProNode(that.form).then(function(resp){
                if(resp.data.code=="200"){
                  that.$message.success(resp.data.msg);
                  that.dialogFormVisible = false;
                  that.getMenu();
                }else{
                  that.$message.error(resp.data.msg);
                }
              },function(){});
            }else{
              delete that.form.child;
              delete that.form.createDate;
              myHttp.editSysNode(that.form).then(function(resp){
                if(resp.data.code=="200"){
                  that.$message.success(resp.data.msg);
                  that.dialogFormVisible = false;
                  that.getMenu();
                }else{
                  that.$message.error(resp.data.msg);
                }
              },function(){});
            }
          }
        });
      },
      //web菜单图片
      handleIconSuccess(res, file){
        this.icon = URL.createObjectURL(file.raw);
        this.form.icon = res.data.saveUrls;
      },
      //web选中菜单图片
      handleIconSuccess1(res,file){
        this.icon2 = URL.createObjectURL(file.raw);
        this.form.icon2 = res.data.saveUrls;
      },
      //app菜单图片
      handleAppSuccess(res, file){
        this.appUrl = URL.createObjectURL(file.raw);
        this.form.appUrl = res.data.saveUrls;
      },
      //菜单删除
      handleDelete(index,data){
        var that = this;
        this.$alert('确认删除该节点吗？', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            if(action=='confirm'){
              myHttp.deleteProNode({
                id:data.id
              }).then(function(resp){
                if(resp.data.code=="200"){
                  that.$message.success("删除成功");
                  that.getMenu();
                }else{
                  that.$message.error(resp.data.msg);
                }
              },function(){});
            }
          }
        });
      },
      //菜单修改弹出框
      handleEdit(index,row){
        console.log(row)
        // var that = this;
        this.dialogFormVisible = true;
        this.form.id = row.id
        this.form.nodeTypeName = row.nodeTypeName
        this.form.parentName = row.parentName
        this.form.parentId = row.parentId
        this.form.nodeType = row.nodeType
        this.form.sort = row.sort
        this.parent.name = row.parentName
        this.parent.id = row.parentId
        // myHttp.editSysNode({
        //   id:data.id
        // }).then(function(resp){
        //   if(resp.data.code=="200"){
        //     var data = resp.data.data.menu;
        //     that.form = data;
        //     that.dialogFormVisible = true;
        //   }else{
        //     that.$message.error(resp.data.msg); 
        //   }
        // });
      },
      //关闭弹出框触发方法
      closeFun(){
        this.form = {
          id:'',
          nodeTypeName: '',
          parentName:'',
          parentId:'',
          nodeType:'',
          sort:'',
        }
      }
    }
  }
</script>
<style scoped>
.content{
  width: 100%;
  height: 100%;
  background: #fff;
}
.demo-form-inline{
  display: flex;
  justify-content:space-between;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd;
}
.pagetitle{
  font-size: 18px;
}
.pageHead .el-form-item{
  margin: 0;
}
/* 图片 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
<style>
   .menuAdmin .el-form-item__content{
     text-align: left;
   }
   .menuAdmin .el-dialog{
      padding-right: 20px;
    }
    .is-current>.el-tree-node__content{
      color: #409EFF;
    }
</style>